module.exports = __webpack_public_path__ + "static/media/measure2_active.6e17f3a9.png";